export default __webpack_public_path__ + "f8aee754e7102375e016494e60b656dd.jpg";